export default {"src":"/_next/static/media/account-account-info-icon.0d356121.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};